import { FormControl, FormLabel, Input, FormErrorMessage, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const FlagFallOutRateField = ({ value, onChange, error }) => {
  const labelColor = useColorModeValue('black', 'white');
const { darkMode } = useSelector((state) => state.settings);
  return (
    <FormControl isInvalid={!!error} isRequired>
      <FormLabel color={darkMode ? 'white' : 'black'}>Flag Fall Out Rate</FormLabel>
      <Input
        name="flagFallOutRate"
        value={value}
        onChange={onChange}
        placeholder="Flag Fall Out Rate"
        type="number"
        step="0.000001"
        style={{
          background: darkMode ? '#1e2021' : 'white',
               color: `${darkMode ? '#f5f4f3' : 'inherit'}`,
          borderColor: `${darkMode ? '#565557' : '#007bff'}`
        }}
      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default FlagFallOutRateField;
